exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.am-addon-edit[data-v-05bf60d9] {\n  width: 500px;\n}\n.am-addOn-form[data-v-05bf60d9] {\n  padding: 15px;\n}\n.am-addOn-title-bar[data-v-05bf60d9] {\n  height: 40px;\n}\n.am-addOn-title[data-v-05bf60d9] {\n  font-size: 16px;\n  color: #FDFEFE;\n  float: left;\n  margin: 10px 0px 0px 15px;\n}\n.am-addOn-blue-border[data-v-05bf60d9] {\n  display: block;\n  width: 100%;\n  border-top: 1px solid #4297d7;\n}\n.am-addOn-float-right[data-v-05bf60d9] {\n  margin-left: 320px;\n}\n\n", ""]);

// exports
